// extracted by mini-css-extract-plugin
module.exports = {"matches-list-narrowed-icon":"_3N28j_d1-9RoqS3doNju","groups-select":"_2n9GMkmfuSnsWJ-N6o28"};